import React, { useState } from 'react';
import styled from '@emotion/styled';

import { getColor } from './UICommon';
import { CardAvatar } from '../styledComponent/CardAvatar.style';
import { OnlyTextButton } from '../styledComponent/Buttons.style';

import { Facilitator } from '../steps/ProductInformationStep';
import { FacilitatorInformationPopUp } from './FacilitatorInformationPopUp';

interface StyleProps {
  isCarousel?: boolean;
}

const RootDiv = styled.div`
  margin: ${(props: StyleProps) => (props.isCarousel ? '0 24px 0 0' : '0')};
  text-align: center;
  font-weight: 600;
  line-height: 24px;
  color: ${getColor('BLACK_80')};
  font-size: 16px;
  width: 128px;
`;

const AvatarDiv = styled.div`
  margin: 0 auto 16px;
  width: fit-content;
`;

const P = styled.p`
  margin: 16px 0 1px 0;
`;

const H3 = styled.h3`
  font-size: 24px;
  font-weight: 600;
  line-height: 32px;
  color: ${getColor('BLACK')};
  text-align: center;
  margin-bottom: 2px;
`;

// const PopUpText = styled.p`
//   font-size: 14px;
//   font-weight: 400;
//   line-height: 20px;
//   color: ${getColor('BLACK_60')};
//   text-align: center;
//   margin-bottom: 32px;
// `

const PopUpAbout = styled.p`
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  color: ${getColor('BLACK')};
  margin-bottom: 4px;
`;

const PopDescription = styled.p`
  font-size: 16px;
  font-weight: 300;
  line-height: 24px;
  color: ${getColor('BLACK_60')};
  margin-bottom: 32px;
`;

const Margin = styled.div`
  margin: 32px;
`;

export interface FacilitatorCardProps {
  facilitator: Facilitator;
  isCarousel: boolean;
}

export const FacilitatorCard = ({ facilitator, isCarousel }: FacilitatorCardProps) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div>
      <FacilitatorInformationPopUp open={isOpen} onClose={() => setIsOpen(false)}>
        <Margin>
          <AvatarDiv>
            <CardAvatar src={facilitator.imageLink} size={128} alt={facilitator.name} />
          </AvatarDiv>
          <H3>{facilitator.name}</H3>
          {/* <PopUpText>{facilitator.gender}</PopUpText> */}
          <PopUpAbout>About me</PopUpAbout>
          <PopDescription>{facilitator.bio}</PopDescription>
        </Margin>
      </FacilitatorInformationPopUp>

      <RootDiv isCarousel={isCarousel}>
        <CardAvatar src={facilitator.imageLink} size={128} alt={facilitator.name} />
        <P>{facilitator.name.split(' ')[0]}</P>
        <OnlyTextButton onClick={() => setIsOpen(true)}>Read bio</OnlyTextButton>
      </RootDiv>
    </div>
  );
};
